import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { seo } from "../../utils/utils";
import "./Terms.css";

const TERM_SECTIONS = [
  { id: "1", titleKey: "termsSection1Title", bodyKey: "termsSection1Body" },
  { id: "2", titleKey: "termsSection2Title", bodyKey: "termsSection2Body" },
  { id: "3", titleKey: "termsSection3Title", bodyKey: "termsSection3Body" },
  { id: "4", titleKey: "termsSection4Title", bodyKey: "termsSection4Body" },
  { id: "5", titleKey: "termsSection5Title", bodyKey: "termsSection5Body" },
  { id: "6", titleKey: "termsSection6Title", bodyKey: "termsSection6Body" },
  { id: "7", titleKey: "termsSection7Title", bodyKey: "termsSection7Body" },
];

const TermAndCondition = () => {
  const navigate = useNavigate();
  const [openId, setOpenId] = useState("1");

  useEffect(() => {
    seo({
      title: "Terms and Conditions",
      metaDescription: "Terms and conditions",
      canonicalLink: window.location.href,
    });
  }, []);

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/login");
  };

  const toggleSection = (id) => {
    setOpenId((current) => (current === id ? "" : id));
  };

  return (
    <Fragment>
      <div className="justo-terms-page">
        <div className="justo-terms">
          <div className="justo-terms__backdrop" aria-hidden="true">
            <div className="justo-terms__backdrop-grid" />
          </div>

          <div className="justo-terms__shell">
            <div className="justo-terms__card">
              <div className="justo-terms__brand-row">
                <img
                  className="justo-terms__brand"
                  src="/assets/images/JUSTOLOGO.jpg"
                  alt="Justo"
                />
              </div>

              <div className="justo-terms__intro">
                <h1 className="justo-terms__title">{strings.termsPageTitle}</h1>
                <p className="justo-terms__subtitle">{strings.termsPageIntro}</p>
              </div>

              <div className="justo-terms__overview">
                <p className="justo-terms__overview-label">
                  {strings.termsOverviewTitle}
                </p>
                <p className="justo-terms__overview-body">
                  {strings.termsOverviewBody}
                </p>
              </div>

              <div className="justo-terms__accordion">
                {TERM_SECTIONS.map((section) => {
                  const isOpen = openId === section.id;
                  return (
                    <div
                      key={section.id}
                      className={`justo-terms__item${isOpen ? " is-open" : ""}`}
                    >
                      <button
                        type="button"
                        className="justo-terms__item-trigger"
                        aria-expanded={isOpen}
                        onClick={() => toggleSection(section.id)}
                      >
                        <span className="justo-terms__item-label">
                          {strings[section.titleKey]}
                        </span>
                        <span className="justo-terms__item-icon" aria-hidden="true">
                          {isOpen ? "−" : "+"}
                        </span>
                      </button>
                      {isOpen ? (
                        <div className="justo-terms__item-panel">
                          <p>{strings[section.bodyKey]}</p>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>

              <div className="justo-terms__actions">
                <button
                  type="button"
                  className="justo-terms__btn justo-terms__btn--ghost"
                  onClick={goBack}
                >
                  {strings.termsBack}
                </button>
                <button
                  type="button"
                  className="justo-terms__btn justo-terms__btn--solid"
                  onClick={() => navigate("/privacypolicy")}
                >
                  {strings.loginPrivacyLink}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TermAndCondition;
